import Immutable from 'immutable';

import { STATUS_TYPES, GLOBAL_MESSAGING_ID, NO_OP_ACTION_TYPE } from 'app/constants/MessagingConstants';

export const MESSAGE_ACTION_GENERIC_ERROR = {
  messaging: Immutable.fromJS({
    [GLOBAL_MESSAGING_ID]: {
      message: Immutable.Map({
        defaultMessage: 'Error',
        id: GLOBAL_MESSAGING_ID,
        type: STATUS_TYPES.Failure
      }),
      duration: 5000
    }
  }),
  type: NO_OP_ACTION_TYPE
};
